// eslint-disable-next-line import/no-extraneous-dependencies
import { fireEvent } from '@testing-library/react';

export const promiseTimeout = async (time = 800): Promise<void> => {
  await new Promise(resolve => {
    setTimeout(resolve, time);
  });
};
export const changeInput = async (
  element: Document | Node | Element | Window,
  value: string
): Promise<void> => {
  fireEvent.change(element, { target: { value } });
  await promiseTimeout(900);
};
